import { render, staticRenderFns } from "./HeartFilledIcon.vue?vue&type=template&id=53b7fbd0&scoped=true&"
import script from "./HeartFilledIcon.vue?vue&type=script&lang=js&"
export * from "./HeartFilledIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b7fbd0",
  null
  
)

export default component.exports